export const getcentrereport = (state = [], action) => {
  switch (action.type) {
    case "CENTER_REPORT":
      return action.payload.data;
    case "CLEAR_CENTER_REPORT":
      return [];
    default:
      return state;
  }
};
